module.exports = __webpack_public_path__ + "img/common-file-clock.234a7122.svg";